import { Outlet, useLocation } from "react-router-dom";
import Header from "./components/Header.tsx";
import Footer from "./components/Footer.tsx";
import LenisProvider, { useLenis } from "./components/LenisProvider";
import { useEffect } from "react";

const App = () => {
  const location = useLocation();
  const lenis = useLenis();

  // Handle scroll position and hash navigation on route change
  useEffect(() => {
    if (lenis) {
      // Scroll to top on pathname change (no hash)
      if (!location.hash) {
        lenis.scrollTo(0, { immediate: true });
      } else {
        // Scroll to element with hash, with offset for navbar
        const targetId = location.hash.replace("#", "");
        setTimeout(() => {
          lenis.scrollTo(`#${targetId}`, {
            offset: -100, // Adjust for navbar height
            duration: 1.2, // Match Lenis duration
            easing: (t: number) => Math.min(1, 1.001 - Math.pow(1 - t, 4)), // Match Lenis easing
          });
        }, 100); // Small delay to ensure page load
      }
    } else {
      // Fallback to native scroll if Lenis is not initialized
      if (!location.hash) {
        window.scrollTo(0, 0);
      } else {
        const targetId = location.hash.replace("#", "");
        const element = document.getElementById(targetId);
        if (element) {
          window.scrollTo({
            top: element.offsetTop - 100, // Adjust for navbar
            behavior: "smooth",
          });
        }
      }
    }
  }, [location.pathname, location.hash, lenis]); // Run on route or hash change

  // const hideHeaderFooterRoutes = ["/links", "/thankyou"];
  const hideHeaderFooterRoutes = ["/links"];

  const showHeaderFooter = !hideHeaderFooterRoutes.includes(location.pathname);

  return (
    <LenisProvider>
      {showHeaderFooter && <Header />}
      <Outlet />
      {showHeaderFooter && <Footer />}
    </LenisProvider>
  );
};

export default App;
